<template>
    <div class="modal show" id="numberRegistration_popup">
        <div class="modal_box">
            <p class="modal_title">
                {{ $store.getters.getRefreshModalText }}
            </p>
            <div class="modal_btnbox">
                <button type="button" class="btn close_btn" @click="closeModal">확인</button>
            </div>
        </div>
    </div>
</template>

<script setup>
const closeModal = () => {
    window.location.reload();
}
</script>

<style scoped></style>